import { l } from '../../lib/imports'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { textInputs } from '../../uiParts/textInputs-sidecar'
import { EVoyageCrewDamageType } from './multi/voyageMessageCrewHurt'
import { voyageMessageCrewHurt } from './multi/voyageMessageCrewHurt-sidecar'

import { EHostCommand } from './multi/voyageMessageHostCommand'
import { voyageMessageHostCommand } from './multi/voyageMessageHostCommand-sidecar'

import { voyageCamera_shaker } from './voyageCamera_shaker-sidecar'
import { voyageColors } from './voyageColors-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageGameMode_tutorial } from './voyageGameMode_tutorial-sidecar'
import { voyagePicker } from './voyagePicker-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTilemapEditor } from './voyageTilemapEditor-sidecar'
import { voyageToolBodyAlign } from './voyageToolBodyAlign-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

const namespace = 'keys-voyager'

let keys = {
  godMode: false,
  shift: false,
  control: false,
  alt: false,

  cameraUp: false,
  cameraDown: false,
  cameraLeft: false,
  cameraRight: false,
}

export const getKeys = () => {
  return keys
}

interface IKeyHandler {
  code: string
  on?: () => void
  off?: () => void
  change?: (isDown: boolean) => void
}
let _handlers: IKeyHandler[] = []

const addHandler = (
  codes: string | string[],
  on: () => void = () => {},
  off: () => void = () => {},
  change: (isDown: boolean) => void = () => {},
) => {
  if (!l.isArray(codes)) {
    codes = [codes]
  }
  l.forEach(codes, (c) => {
    _handlers.push({ code: c, on, off, change })
  })
}

const addKey = (codes: string | string[], property: keyof typeof keys) => {
  addHandler(
    codes,
    () => {},
    () => {},
    (isDown) => {
      // console.log('key property changed', codes, property, isDown)
      keys[property] = isDown
    },
  )
}

export const create = () => {
  let s = common.getPhaserScene()

  l.forEach(textInputs.textInputAlphabet, (c) => {
    s.input.keyboard.addKey(c)
  })

  const isEditor = () => {
    return voyageGameManager.get().mode === 'editor'
  }
  const isBodyAlign = () => {
    return voyageGameManager.get().mode === 'body-align'
  }
  console.log(namespace, 'create voyage keyboard')

  addKey(['ShiftLeft', 'ShiftRight'], 'shift')
  addKey(['ControlLeft', 'ControlRight'], 'control')
  addKey(['AltLeft', 'AltRight'], 'alt')

  addKey(['KeyW', 'ArrowUp'], 'cameraUp')
  addKey(['KeyA', 'ArrowLeft'], 'cameraLeft')
  addKey(['KeyS', 'ArrowDown'], 'cameraDown')
  addKey(['KeyD', 'ArrowRight'], 'cameraRight')

  s.input.keyboard.addKey('Space')
  addHandler('Space', () => {
    voyageGameManager.togglePause()
  })

  s.input.keyboard.addKey('ESC')
  addHandler('Escape', () => {
    voyagePicker.clearSelection()
  })

  s.input.keyboard.addKey(34) // Pagedown
  addHandler('PageDown', () => {
    if (voyageWebsockets.getIsHost()) {
      // console.log('PAGEDOWN!!')
      // Kill a random crewmember
      let crs: IVoyageCrew[] = []
      l.forEach(voyageCrew.getAll(), (c) => {
        if (c.type === EVoyageCrewType.Crew) {
          crs.push(c)
          // voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
          //   crewId: c.id,
          //   newHitpoints: -100,
          //   type: EVoyageCrewDamageType.Suicide,
          //   byCrewId: 0,
          // })
          // voyageCrew.makeDeadish(c, EVoyageCrewDamageType.Suicide) //'Suicide')
        }
      })
      // console.log('PAGEDOWN!!', crs.length)
      if (crs.length > 0) {
        let cr = rando.sample(crs)
        // console.log('hurt', cr.id)
        voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
          crewId: cr.id,
          newHitpoints: -100,
          type: EVoyageCrewDamageType.Suicide,
          byCrewId: 0,
        })
      }
    }
  })

  s.input.keyboard.addKey('END')
  addHandler('End', () => {
    if (voyageWebsockets.getIsHost()) {
      l.forEach(voyageCrew.getAll(), (c) => {
        if (c.type === EVoyageCrewType.Crew) {
          voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
            crewId: c.id,
            newHitpoints: -100,
            type: EVoyageCrewDamageType.Suicide,
            byCrewId: 0,
          })
          // voyageCrew.makeDeadish(c, EVoyageCrewDamageType.Suicide) //'Suicide')
        }
      })
    }
  })

  s.input.keyboard.addKey('HOME')
  addHandler('Home', () => {
    if (voyageWebsockets.getIsHost()) {
      voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
        command: EHostCommand.Reset,
      })
    }
  })

  // document.onkeypress(ev)

  s.input.keyboard.addKey('TAB')
  addHandler('Tab', () => {
    voyagePicker.nextSelection(1)
    //let keys = getKeys()
    //voyagePicker.nextSelection(keys.shift ? -1 : 1)
  })

  addHandler('Backquote', () => {
    voyagePicker.nextSelection(-1)
    //let keys = getKeys()
    //voyagePicker.nextSelection(keys.shift ? -1 : 1)
  })

  addHandler('KeyP', () => {
    voyageSounds.toggleSounds()
  })
  addHandler('KeyM', () => {
    voyageSounds.toggleMusic()
  })

  addHandler('KeyX', () => {
    voyageGameMode_tutorial.signalSkip()
  })

  if (voyageTestParams.isDevMode) {
    addHandler('KeyE', () => {
      voyageCamera_shaker.shake()
    })
    addHandler('Digit1', () => {
      voyageTilemapEditor.get().mode = 'old'
      voyageTilemapEditor.get().layerIdx = 1
    })
    addHandler('Digit2', () => {
      voyageTilemapEditor.get().mode = 'old'
      voyageTilemapEditor.get().layerIdx = 2
    })
    addHandler('Digit3', () => {
      voyageTilemapEditor.get().mode = 'old'
      voyageTilemapEditor.get().layerIdx = 3
    })
    addHandler('Digit4', () => {
      voyageTilemapEditor.get().cutMode = !voyageTilemapEditor.get().cutMode
    })

    addHandler('Digit5', () => {
      voyageTilemapEditor.get().mode = 'hull'
    })
    addHandler('Digit6', () => {
      voyageTilemapEditor.get().mode = 'sys'
    })
    addHandler('Digit7', () => {
      voyageTilemapEditor.get().mode = 'floor'
    })
    addHandler('Digit8', () => {
      voyageTilemapEditor.get().mode = 'decor'
    })

    addHandler('Delete', () => {
      voyageTilemapEditor.clearArea()
    })

    addHandler('KeyJ', () => {
      voyageTilemapEditor.cut(-1, 0)
    })
    addHandler('KeyL', () => {
      voyageTilemapEditor.cut(1, 0)
    })

    addHandler('KeyI', () => {
      voyageTilemapEditor.cut(0, -1)
    })
    addHandler('KeyK', () => {
      voyageTilemapEditor.cut(0, 1)
    })

    addHandler('Numpad1', () => {
      voyageTestParams.setTestMode('normal')
    })
    addHandler('Numpad2', () => {
      voyageTestParams.setTestMode('editor')
    })
    addHandler('Numpad3', () => {
      voyageTestParams.setTestMode('game')
    })
    addHandler('Numpad4', () => {
      voyageTestParams.setTestMode('body-align')
    })
    addHandler('Numpad5', () => {
      voyageTestParams.setTestMode('test')
    })

    addHandler('KeyA', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(-1, 0, 0, 0)
      }
    })
    addHandler('KeyD', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(1, 0, 0, 0)
      }
    })

    addHandler('KeyW', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, -1, 0, 0)
      }
    })
    addHandler('KeyS', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, 1, 0, 0)
      }
    })

    addHandler('ArrowLeft', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, 0, -1, 0)
      }
    })
    addHandler('ArrowRight', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, 0, 1, 0)
      }
    })

    addHandler('ArrowUp', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, 0, 0, -1)
      }
    })
    addHandler('ArrowDown', () => {
      if (isBodyAlign()) {
        voyageToolBodyAlign.adjust(0, 0, 0, 1)
      }
    })

    addHandler('Numpad7', () => {
      if (isEditor()) {
        voyageTilemapEditor.runFixer()
      }
      if (isBodyAlign()) {
        voyageToolBodyAlign.get().bodyIdx++
      }
    })

    addHandler('Numpad8', () => {
      if (isEditor()) {
        voyageTilemapEditor.runPaintFloors(voyageColors.g1)
      }
      if (isBodyAlign()) {
        voyageToolBodyAlign.get().headIdx++
      }
    })
    addHandler('Numpad9', () => {
      if (isEditor()) {
        voyageTilemapEditor.runPaintFloors(0x00ff00)
      }
      if (isBodyAlign()) {
        voyageToolBodyAlign.get().hairIdx++
      }
    })
  }

  console.log(namespace, 'add keyboard handler')
  s.input.keyboard.on('keydown', (event: any) => {
    console.log(
      namespace,
      'key down',
      'key',
      event.key,
      'keyCode',
      event.keyCode,
      'code',
      event.code,
    )

    // if (underMenuController.handleKeydown(event.code)) {
    //   return
    // }

    if (textInputs.hasFocus()) {
      textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
    } else {
      l.forEach(_handlers, (c) => {
        if (c.code === event.code) {
          console.log(namespace, 'hit handler')
          if (c.on) {
            c.on()
          }
          if (c.change) {
            c.change(true)
          }
        }
      })
    }
  })

  s.input.keyboard.on('keyup', (event: any) => {
    if (textInputs.hasFocus()) {
      textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
    } else {
      l.forEach(_handlers, (c) => {
        if (c.code === event.code) {
          if (c.off) {
            c.off()
          }
          if (c.change) {
            c.change(false)
          }
        }
      })
    }
  })
}
